export function getSelection() {
	let t:any = '';
	if (window.getSelection) {
		t = window.getSelection();
	} else if (document.getSelection) {
		t = document.getSelection();
	}

	return t;	
}

export function replaceChar(origString:string, replaceChar:string, index:number) {
	let firstPart = index === 0 ? '' : origString.substr(0, index);
	let lastPart = origString.substr(index + 1);

	return firstPart + replaceChar + lastPart;;
}